export const commonNouns = [
  // Animals
  'cat', 'dog', 'bird', 'fish', 'rat', 'pig', 'cow', 'fox', 'bear', 'deer',
  // Body parts
  'hand', 'foot', 'eye', 'ear', 'nose', 'head', 'arm', 'leg', 'hair',
  // Nature
  'sun', 'moon', 'star', 'tree', 'leaf', 'rain', 'snow', 'wind', 'sand', 'rock',
  // Food
  'cake', 'bread', 'meat', 'fish', 'rice', 'milk', 'egg', 'pie', 'salt',
  // Objects
  'book', 'pen', 'door', 'key', 'bed', 'chair', 'desk', 'lamp', 'clock', 'ring',
  'box', 'bag', 'cup', 'plate', 'knife', 'fork', 'spoon', 'phone', 'car',
  // Clothing
  'hat', 'coat', 'shoe', 'sock', 'belt', 'dress', 'shirt',
  // House
  'roof', 'wall', 'floor', 'room', 'door', 'house', 'home',
  // Tools
  'nail', 'tool', 'saw', 'axe', 'rope', 'wire',
  // Weather
  'rain', 'snow', 'wind', 'storm', 'cloud', 'fog',
  // Time
  'day', 'night', 'week', 'month', 'year', 'time',
  // Colors
  'red', 'blue', 'green', 'gold', 'pink',
  // Materials
  'wood', 'steel', 'iron', 'gold', 'glass', 'clay',
  // Misc
  'game', 'toy', 'gift', 'song', 'word', 'name', 'mind', 'heart', 'soul',
  'king', 'queen', 'child', 'baby', 'girl', 'boy', 'man', 'fire', 'ice',
  'light', 'dark', 'road', 'path', 'way', 'line', 'side', 'top', 'end'
]; 